export default "__VITE_ASSET__7YQH4cra__"